import Markdown from 'react-markdown';
import { useLocale } from 'remix-i18next/react';
import { useTypedRouteLoaderData } from 'remix-typedjson';
import { useEditableTranslation } from '#common/i18n/edit-mode.tsx';
import { useTranslatedPath } from '#common/utils/i18n.tsx';
import { FaceLayout } from '#speaker-shop/components/FaceLayout.tsx';
import { NavigateToHome } from '#speaker-shop/components/NavigateToHome.tsx';
import { type loader as rootLoader } from '#speaker-shop/root';

export const handle = { i18n: [ 'gtc' ] };

export default function Gtc() {
    const { t, rawT } = useEditableTranslation('gtc');
    const { t: tCommon } = useEditableTranslation('common');
    const translatePath = useTranslatedPath(useLocale());
    const rootData = useTypedRouteLoaderData<typeof rootLoader>('root')!;
    if ('unifiedShopPage' in rootData && rootData.unifiedShopPage) {
        return (
            <article className='core-legal-page core-legal-prose'>
                <a className='core-back-button mb-8' href={translatePath('/')}>← {tCommon('navigate-to-home')}</a>
                <h1>{t('heading')}</h1>
                <Markdown>{rawT('text')}</Markdown>
            </article>
        );
    }
    return (
        <>
            <FaceLayout faceSize='small'>
                <NavigateToHome className='hidden lg:flex' />
                <div className='my-auto p-8 md:p-20 lg:p-0'>
                    <NavigateToHome className='lg:hidden flex' />
                    <h1 className='text-3xl md:text-4xl lg:text-5xl font-medium text-black hyphens-auto'>
                        {t('heading')}
                    </h1>
                </div>
            </FaceLayout>
            <div className='prose mx-auto max-w-7xl text-black md:prose-lg lg:prose-xl p-8 md:p-20 hyphens-auto'>
                <Markdown>{rawT('text')}</Markdown>
            </div>
        </>
    );
}
